import message from "components/CustomMessage";
import { cloneDeep, isEmpty, isNil, omit, omitBy } from "lodash";
import { Marked, marked } from "marked";
import moment from "moment";
import { DraftFindingRequestDto } from "types/api/draftFindingRequestDto";
import { DraftFindingResponse } from "types/api/draftFindingResponse";

export const convertResponseToRequestDto = (response: DraftFindingResponse) => {
  const requestDto: DraftFindingRequestDto = {
    ...response,
  };

  return requestDto;
};

export const validateDraftForPublish = async (draft: DraftFindingResponse) => {
  const requiredFields = [];
  if (isEmpty(draft.title)) {
    requiredFields.push("Summary");
  }
  if (isEmpty(draft.severity)) {
    requiredFields.push("Severity");
  }
  if (isEmpty(draft.environmentName)) {
    requiredFields.push("Environment");
  }
  if (requiredFields.length > 0) {
    const errorMessage = `${requiredFields.join(", ")} ${
      requiredFields.length === 1 ? "is" : "are"
    } required for publishing.`;
    message.error(errorMessage);
    throw new Error(errorMessage);
  }
};

export const convertDraftToPublish = (
  assessmentId: number,
  draft: DraftFindingResponse,
) => {
  const {
    title,
    baseScore,
    category,
    componentFixVersions,
    componentName,
    componentVersion,
    cves,
    cvssVector,
    cwes,
    description,
    exploited,
    findingCategory,
    impact,
    mitigation,
    scanType,
    severity,
    stepsToReproduce,
    scanDate,
    ownerId,
    vendor,
    vmHostName,
  } = draft;
  return omitBy(
    {
      assessment: [assessmentId],
      title,
      description,
      stepsToReproduce,
      mitigation,
      impact,
      severity,
      scanType,
      testType: category, // tool category
      armorcodeCategory: findingCategory,
      cvssScore: baseScore || null,
      cvssVector: cvssVector || null,
      componentName,
      componentVersion,
      componentFixVersions,
      exploited,
      cwe: cwes?.length ? cwes.join(",") : undefined,
      cve: cves?.length ? cves.join(",") : undefined,
      scanDate: scanDate
        ? moment(scanDate).utc().format("YYYY-MM-DD HH:mm:ss")
        : undefined,
      ownerId,
      vendor,
      device: vmHostName,
    },
    isNil,
  );
};

export const convertTemplateToDraft = (template: DraftFindingResponse) => {
  const draft: DraftFindingResponse = omit(cloneDeep(template), "id");
  convertMarkdownToHtmlFields(draft);
  draft.outOfBox = false;
  return draft;
};

export const convertMarkdownToHtmlFields = (
  draft: DraftFindingResponse,
  markedInstance?: Marked,
) => {
  // use parseInline to avoid enclosing everything inside <p>
  // renderer is configured globally via marked.use() in MarkupFormatter
  const parser = markedInstance ?? marked;
  if (draft.description) {
    draft.description = parser.parseInline(draft.description) as string;
  }
  if (draft.stepsToReproduce) {
    draft.stepsToReproduce = parser.parseInline(
      draft.stepsToReproduce,
    ) as string;
  }
  if (draft.impact) {
    draft.impact = parser.parseInline(draft.impact) as string;
  }
  if (draft.mitigation) {
    draft.mitigation = parser.parseInline(draft.mitigation) as string;
  }
};
